"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
const vue_1 = require("vue");
const CardRequirementsComponent_1 = require("./CardRequirementsComponent");
const CardVictoryPoints_1 = require("./CardVictoryPoints");
const CardDescription_1 = require("./CardDescription");
const CardRenderData_1 = require("./CardRenderData");
exports.CardContent = vue_1.default.component('CardContent', {
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        requirements: {
            type: Object,
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        CardRequirementsComponent: CardRequirementsComponent_1.CardRequirementsComponent,
        CardVictoryPoints: CardVictoryPoints_1.CardVictoryPoints,
        CardDescription: CardDescription_1.CardDescription,
        CardRenderData: CardRenderData_1.CardRenderData,
    },
    methods: {
        getClasses: function () {
            const classes = ['card-content'];
            if (this.isCorporation) {
                classes.push('card-content-corporation');
            }
            return classes.join(' ');
        },
    },
    template: `
        <div :class="getClasses()">
            <CardRequirementsComponent v-if="requirements !== undefined" :requirements="requirements"/>
            <CardRenderData v-if="metadata.renderData !== undefined" :renderData="metadata.renderData" />
            <CardDescription v-if="metadata.description !== undefined" :item="metadata.description" />
            <CardVictoryPoints v-if="metadata.victoryPoints !== undefined" :victoryPoints="metadata.victoryPoints" />
        </div>
    `,
});
//# sourceMappingURL=CardContent.js.map